import React from 'react'
import Scroll from 'react-scroll'

const scroller = Scroll.scroller;

const ReactScrollLink = ({className = '', children, offset, smooth, onClick, to}) => {
  const scroll = () => {
    if(onClick) {
      onClick()
    }
    
    const scrollFunction = () => {
      if(to) {
        scroller.scrollTo(to, {
          smooth: smooth,
          offset: offset,
          isDynamic: true
        })
      }
    }
    _.delay(scrollFunction ,100)
  }

  return (
      <div className={className} onClick={scroll}>
        {children}
      </div>
    );
  }

export default ReactScrollLink